<template>
  <div class="text-editor-comp">
    <div class="editor-panes">
      <div class="editor-pane">
        <div class="pane-header">
          <span class="pane-dot input-dot" />
          <span class="pane-label">输入</span>
          <span class="pane-hint">在此输入文本内容</span>
        </div>
        <el-input
          v-model="input" type="textarea"
          :rows="inputRows" :placeholder="inputPlaceholder"
          class="code-textarea" @input="process"
        />
      </div>
      <div class="editor-pane">
        <div class="pane-header">
          <span class="pane-dot output-dot" />
          <span class="pane-label">输出</span>
          <span class="pane-hint" v-if="input">字符 {{ input.length }}</span>
        </div>
        <el-input
          v-model="output" type="textarea"
          :rows="inputRows" readonly
          class="code-textarea output-area"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextEditor',
  props: { config: { type: Object, default: () => ({}) } },
  data: () => ({ input: '', output: '' }),
  computed: {
    inputRows() { return (this.config.input && this.config.input.rows) || 12 },
    inputPlaceholder() { return (this.config.input && this.config.input.placeholder) || '请输入文本...' }
  },
  methods: {
    process() { this.output = this.input },
    doAction(action) {
      switch (action) {
        case 'copy': navigator.clipboard.writeText(this.output); this.$message.success(this.$t("common.status.copied")); break
        case 'clear': this.input = ''; this.output = ''; break
        case 'paste': navigator.clipboard.readText().then(t => { this.input = t; this.process() }); break
        case 'sample': this.input = 'Hello World!\nThis is a sample text.\nLine 3 here.'; this.process(); break
      }
    }
  }
}
</script>

<style scoped>
.editor-panes { display: flex; gap: 18px; }
.editor-pane {
  flex: 1; min-width: 0;
  background: #fafbfc; border-radius: 12px;
  border: 1px solid #ebeef5; padding: 16px;
  transition: border-color 0.2s;
}
.editor-pane:focus-within { border-color: #4e7cff; }
.pane-header {
  display: flex; align-items: center; gap: 8px; margin-bottom: 12px;
}
.pane-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }
.input-dot { background: #4e7cff; box-shadow: 0 0 6px rgba(78,124,255,0.4); }
.output-dot { background: #43e97b; box-shadow: 0 0 6px rgba(67,233,123,0.4); }
.pane-label { font-size: 13px; font-weight: 700; color: #1a1f36; letter-spacing: 0.5px; }
.pane-hint { font-size: 11px; color: #b0b8c4; margin-left: auto; }
.code-textarea >>> textarea {
  font-family: 'JetBrains Mono', 'Fira Code', 'Consolas', 'Monaco', monospace !important;
  font-size: 13px !important; line-height: 1.6 !important;
  border-radius: 8px; border-color: #e4e7ed;
  background: #fff; resize: none;
}
.output-area >>> textarea { background: #fafbfc; color: #4a5568; }

@media (max-width: 640px) { .editor-panes { flex-direction: column; } }
</style>
